/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SegmentsGetHlsPlaylistQueryResponse, SegmentsGetHlsPlaylistPathParams, SegmentsGetHlsPlaylistQueryParams, SegmentsGetHlsPlaylist400, SegmentsGetHlsPlaylist401, SegmentsGetHlsPlaylist403, SegmentsGetHlsPlaylist404 } from "../models/SegmentsGetHlsPlaylist";

export function getSegmentsGetHlsPlaylistUrl(station: SegmentsGetHlsPlaylistPathParams["station"]) {
  const res = { method: 'GET', url: `/segments/v1/stations/${station}/hls` as const }
  return res
}

/**
 * @description Returns an HLS media playlist (M3U8) covering recorded segments in the given interval. Supports optional `#EXT-X-START` and byte-range segment URIs via query parameters.
 * @summary Get VOD HLS playlist for a time range
 * {@link /segments/v1/stations/:station/hls}
 */
export async function segmentsGetHlsPlaylist(station: SegmentsGetHlsPlaylistPathParams["station"], params: SegmentsGetHlsPlaylistQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SegmentsGetHlsPlaylistQueryResponse, ResponseErrorConfig<SegmentsGetHlsPlaylist400 | SegmentsGetHlsPlaylist401 | SegmentsGetHlsPlaylist403 | SegmentsGetHlsPlaylist404>, unknown>({ method : "GET", url : getSegmentsGetHlsPlaylistUrl(station).url.toString(), params, ... requestConfig })
  return res.data
}